// extracted by mini-css-extract-plugin
export default {"headingYellow":"BuyDIDCongratulations_headingYellow__JiQ5h"};